import { render, staticRenderFns } from "./ExpansionContainer.vue?vue&type=template&id=eb0f0976&scoped=true&"
import script from "./ExpansionContainer.vue?vue&type=script&lang=js&"
export * from "./ExpansionContainer.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionContainer.vue?vue&type=style&index=0&id=eb0f0976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0f0976",
  null
  
)

export default component.exports